<template>
  <div>
    <img v-if="pc" :src="$t('country.img')" width="100%" />
    <img v-else :src="$t('country.imgm')" width="100%" />
    <div v-if="!pc" style="position: fixed;z-index: 9">
      <div v-show="!mf" style="margin-left: -5px;color: #7f1f20;font-size: 30px" @click="mf = !mf">
        <a-icon type="caret-right" />
      </div>
      <div v-show="mf" style="margin-left: -20px">
        <div class="navigation_m" style="width: 230px">
          <div @click="mf = !mf" style="font-size: 30px">
            <a-icon type="caret-left" />
          </div>
          <div :class="{active_m : index === 0}" @click="query(0, 'all')">
            <span>{{$t('country.all.name')}}</span>
          </div>
          <div style="background: white;color: #7F1F20;margin-left: 10%">{{$t('country.search.name')}}</div>
          <div :class="{active_m : index === 99}" @click="query(99 ,'continent')">
            <span>{{$t('country.continent.name')}}</span></div>
          <div :class="{active_m : index === 1}" @click="query(1, 'eu')">
            <span>{{$t('country.eu.name')}}</span></div>
          <div :class="{active_m : index === 2}" @click="query(2, 'schengen')">
            <span>{{$t('country.schengen.name')}}</span></div>
          <div :class="{active_m : index === 12}" @click="query(12, 'eurozone')">
            <span>{{$t('country.eurozone.name')}}</span></div>
          <div :class="{active_m : index === 3}" @click="query(3, 'asean')">
            <span>{{$t('country.asean.name')}}</span></div>
          <div :class="{active_m : index === 4}" @click="query(4, 'sco')">
            <span>{{$t('country.sco.name')}}</span></div>
          <div :class="{active_m : index === 7}" @click="query(7, 'wto')">
            <span>{{$t('country.wto.name')}}</span></div>
          <div :class="{active_m : index === 9}" @click="query(9, 'oecd')">
            <span>{{$t('country.oecd.name')}}</span></div>
          <div :class="{active_m : index === 11}" @click="query(11, 'g20')">
            <span>{{$t('country.g20.name')}}</span></div>
          <div :class="{active_m : index === 13}" @click="query(13, 'apec')">
            <span>{{$t('country.apec.name')}}</span></div>
        </div>
      </div>
    </div>
    <div class="mw1200" :class="{mlr: !pc}" style="margin: 60px auto 150px auto">
      <div class="h1_p">
        <h1 :class="{f36: !pc}">{{$t('menu.country')}}</h1>
        <p :class="{f20: !pc}" :style="{lineHeight: pc?'1.2':'30px'}" v-html="$t('country.p')"></p>
      </div>
      <a-affix v-if="pc" :offset="50">
        <div class="navigation">
          <div :class="{active : index === 0}" @click="query(0, 'all')">
            <span>{{$t('country.all.name')}}</span>
          </div>
          <div style="background: #7F1F20;color: white">{{$t('country.search.name')}}</div>
          <div :class="{active : index === 99}" @click="query(99 ,'continent')">
            <span>{{$t('country.continent.name')}}</span></div>
          <div :class="{active : index === 1}" @click="query(1, 'eu')">
            <span>{{$t('country.eu.name')}}</span></div>
          <div :class="{active : index === 2}" @click="query(2, 'schengen')">
            <span>{{$t('country.schengen.name')}}</span></div>
          <div :class="{active : index === 12}" @click="query(12, 'eurozone')">
            <span>{{$t('country.eurozone.name')}}</span></div>
          <div :class="{active : index === 3}" @click="query(3, 'asean')">
            <span>{{$t('country.asean.name')}}</span></div>
          <div :class="{active : index === 4}" @click="query(4, 'sco')">
            <span>{{$t('country.sco.name')}}</span></div>
          <div :class="{active : index === 7}" @click="query(7, 'wto')">
            <span>{{$t('country.wto.name')}}</span></div>
          <div :class="{active : index === 9}" @click="query(9, 'oecd')">
            <span>{{$t('country.oecd.name')}}</span></div>
          <div :class="{active : index === 11}" @click="query(11, 'g20')">
            <span>{{$t('country.g20.name')}}</span></div>
          <div :class="{active : index === 13}" @click="query(13, 'apec')">
            <span>{{$t('country.apec.name')}}</span></div>
        </div>
        <img src="@/assets/top.png" alt="top" style="margin-left: 125px;cursor: pointer;position: absolute;margin-top: 500px" @click="toTop" />
      </a-affix>
      <div :style="{marginLeft: pc?'235px':'0'}" style="margin: 50px 0 0 235px;min-height: 500px;display: flex">
        <div v-if="index !== 99 && index !== 0" style="margin-right: 20px">
          <img :src="`/acnImg/countries/${id}.png`" width="86" height="86" :alt="id" />
        </div>
        <div>
          <div :style="{fontSize: pc?'24px':'26px'}" style="color: #7F1F20">{{ $t(`country.${id}.h1`) }}</div>
          <div v-if="$t(`country.${id}`).p" :style="{fontSize: pc?'15px':'20px', lineHeight: pc?'23px':'30px'}" style="color: #595959">
            {{$t(`country.${id}.p`)}}
          </div>
          <a-divider v-if="index === 99" style="background: #00023d;margin-top: 0" />
          <div v-if="index !== 99" class="country_list">
            <div v-for="(item, index) in countryList" :key="index" @click="qd(item.id, item.ename, item.nname)"
                 :style="{width: pc?'100px':'20%'}">
              <img :src="`/acnImg/countries/${item.ename}/Flag2.png`" width="30" height="30" />
              <span :class="{f16: !pc}" style="line-height: 16px">{{ isEn ? item.ename : item.nname }}</span>
            </div>
          </div>
          <template v-else>
            <div v-for="(item, index) in countryList2" :key="index" style="margin-bottom: 30px">
              <div style="font-size: 20px;color: #7f1f20">{{item.name}}</div>
              <div class="country_list" style="margin-top: 0">
                <div v-for="(c, i) in item.list" :key="i" @click="qd(c.id, c.ename, c.nname)"
                     :style="{width: pc?'100px':'20%'}"
                >
                  <img :src="`/acnImg/countries/${c.ename}/Flag2.png`" width="30" height="30" />
                  <span :class="{f16: !pc}" style="line-height: 16px">{{ isEn ? c.ename : c.nname }}</span>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import request from '@/utils/request'
export default {
  name: 'CountryList',
  data () {
    return {
      countryList: [],
      countryList2: [],
      index: 0,
      id: 'all',
      mf: false
    }
  },
  computed: {
    ...mapGetters(['isEn', 'pc'])
  },
  methods: {
    async query (i, id) {
      this.index = i
      this.id = id
      if (id === 99) {
        return
      }
      this.countryList = await request.get('/country/list?type=' + i)
      this.toTop()
      this.mf = false
    },
    qd (i, ename, nname) {
      this.$router.push({
        path: '/countryInfo',
        query: {
          id: i,
          nameEn: ename,
          nameZh: nname
        }
      })
    },
    toTop () {
      window.scrollTo(0, 0)
    }
  },
  mounted () {
    request.get('/country/list?type=0').then(res => {
      this.countryList = res
      if (this.countryList2.length) {
        return
      }
      this.countryList2 = this.$t('country.continent.continents')
      this.countryList.forEach(c => {
        if (c.continent <= this.countryList2.length) {
          this.countryList2[c.continent - 1].list.push(c)
        }
      })
    })
  }
}
</script>

<style lang="less">
  .country_list {
    max-width: 965px;
    display: flex;
    flex-wrap: wrap;
    border-left: 1px solid #ebebeb;
    margin-top: 20px;
    > div {
      /*width: 100px;*/
      height: 120px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      text-align: center;
      cursor: pointer;
      border-right: 1px solid #ebebeb;
      border-bottom: 1px solid #ebebeb;
      border-top: 1px solid #ebebeb;

      span {
        margin-top: 7px;
        display: block;
        height: 15px;
      }

      &:hover {
        background: #7F1F20;
        color: #eddc99;
      }
    }
  }
</style>
